import SeoHead from "../components/SeoHead";
import "../styles/policy.css";

const TermsOfUse = () => {
  return (
    <div className="policy-page">
      <SeoHead
        title="Terms of Use"
        description="Terms of use for MohamedGad.com, including acceptable use, content ownership, external links, and professional disclaimers."
        canonical="https://www.mohamedgad.com/terms-of-use"
      />

      <section className="policy-hero">
        <p className="eyebrow">Terms</p>
        <h1>Terms of Use</h1>
        <p>
          These terms apply to MohamedGad.com, a personal and professional site
          publishing original writing, project summaries, and analysis related to
          AI, data science, mobility, transportation operations, and business
          strategy.
        </p>
        <p className="policy-updated">Last updated: July 26, 2026</p>
      </section>

      <section className="policy-section">
        <h2>Use of the site</h2>
        <p>
          You may read, share, and link to public pages on this site. You may not
          use the site to submit spam, attempt unauthorized access, disrupt service,
          copy content for misleading use, or misrepresent the author, publisher,
          or purpose of the content.
        </p>
      </section>

      <section className="policy-section">
        <h2>Original content</h2>
        <p>
          Unless otherwise noted, articles and page content are written by Mohamed
          Gad. You may quote short excerpts with attribution and a link back to the
          original page. Full republication, automated scraping for republication,
          or commercial reuse requires written permission.
        </p>
      </section>

      <section className="policy-section">
        <h2>Professional information</h2>
        <p>
          Content on this site is educational and professional commentary. It is
          not legal, financial, medical, or investment advice. Any decisions based
          on the material should be evaluated with appropriate professional
          judgment and independent verification.
        </p>
      </section>

      <section className="policy-section">
        <h2>External links</h2>
        <p>
          This site may link to third-party websites, research, documentation,
          companies, public agencies, and tools. External sites are provided for
          context and are responsible for their own content, security, and privacy
          practices.
        </p>
      </section>

      <section className="policy-section">
        <h2>Contact</h2>
        <p>
          For permissions or questions about these terms, email{" "}
          <a href="mailto:mohamed@mohamedgad.com">mohamed@mohamedgad.com</a>.
        </p>
      </section>
    </div>
  );
};

export default TermsOfUse;
